export default function broadcasterLogoSelector(broadcaster) {
  switch (broadcaster) {
    case 'npo1':
      return '/static/broadcasterImages/NPO_TV1_Logo.png';
    case 'npo2':
      return '/static/broadcasterImages/NPO_TV2_Logo.png';
    case 'npo3':
      return '/static/broadcasterImages/NPO_TV3_Logo.png';
    case 'zapp':
      return '/static/broadcasterImages/NPO_ZAPP_Logo.png';
    case 'radio1':
      return '/static/broadcasterImages/NPO_RD1_Logo.png';
    case 'radio2':
      return '/static/broadcasterImages/NPO_RD2_Logo.png';
    case '3fm':
      return '/static/broadcasterImages/NPO_3FM_Logo.png';
    case 'radio4':
      return '/static/broadcasterImages/NPO_RD4_Logo.png';
    case 'radio5':
      return '/static/broadcasterImages/NPO_RD5_Logo.png';
    case 'funx':
      return '/static/broadcasterImages/NPO_FUNX_Logo.png';
    case 'youtube':
      return '/static/broadcasterImages/YouTube_Logo.png';
    case 'npostart':
      return '/static/broadcasterImages/NPO_Start_Logo.svg';
    default:
      return null;
  }
}
